import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IPartnerGroupInfo } from 'legacy/lut/classes/models/partner360/IPartnerGroup'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchPartnerGroup = async (
  groupId: number,
  forceFetch?: boolean
): Promise<IPartnerGroupInfo | null> => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPPartnerGroupInfo, 'getPartnerGroup')
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'GroupId',
        operator: Operator.EQUAL,
        value: groupId,
      },
    ],
  })

  const res = await crud.fetch({ force: forceFetch })
  return res?.items?.[0] || null
}
